<template>
  <section>
    <TheArticleList
      :articles="artworks.data"
      linkPath="artwork"
      displayType="card"
    >
      <template>
        <TheListTitle :listTitle="articleTitle" prefix="artwork" />
        <ArticleFilter>
          <div class="selector-group">
            <TheSelect
              @onChange="(value) => handleChange('locale', value)"
              @onReset="handleReset('locale')"
              :options="localeOptions"
              placeholder="行政區"
            />
            <TheSelect
              @onChange="(value) => handleChange('mainGroup', value)"
              @onReset="handleReset('mainGroup')"
              :options="mainGroupOptions"
              placeholder="藝品主分類"
            />
          </div>
          <div class="selector-group">
            <TheSelect
              ref="subGroup"
              @onChange="(value) => handleChange('subGroup', value)"
              @onReset="handleReset('subGroup')"
              :options="subGroupOptions"
              noOptionsText="請先選擇藝品主分類"
              placeholder="藝品次分類"
            />
            <TheSelect
              @onChange="(value) => handleChange('author', value)"
              @onReset="handleReset('author')"
              :options="authorOptions"
              placeholder="藝師"
            />
          </div>
        </ArticleFilter>
      </template>
    </TheArticleList>
    <TheListPagination
      category="artworks"
      :pages="artworks"
      @update:getUpdatedArticles="$store.dispatch('getUpdatedArticles', $event)"
    />
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';
// import { lazyloading } from '@/utils/lazyloading';

import TheListTitle from '@/components/list/TheListTitle';
import ArticleFilter from '@/components/list/ArticleFilter';
import TheArticleList from '@/components/list/TheArticleList';
import TheListPagination from '@/components/list/TheListPagination';
import TheSelect from '@/components/TheSelect';
import hero from '@/assets/images/home/hero.jpeg';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'TheArtworks',
  metaInfo() {
    return {
      title: '藝品導覽',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: '臺南宗教藝術-藝品導覽',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: '收錄本站目前介紹的臺南宗教藝術。',
        },
        // 之後可能會動態使用第一篇文章的刊頭照片
        // {
        //   vmid: 'og:image',
        //   property: 'og:image',
        //   content: this.artworkHeroImage
        // }
      ],
    };
  },
  data() {
    return {
      locale: null,
      author: null,
      mainGroup: null,
      subGroup: null,
    };
  },
  computed: {
    ...mapGetters(['artworks', 'artworkFilter', 'productionHostname']),
    articleTitle() {
      return getArticleString('artwork', 'headline');
    },
    productionWholeReference() {
      return `${this.productionHostname}${window.location.pathname}${window.location.search}`;
    },
    // 之後可能會動態使用第一篇文章的刊頭照片
    artworkHeroImage() {
      const hasArtworks = this.artworks && this.artworks.data.length > 0;
      return hasArtworks ? this.artworks.data[0].cover_image_url : hero;
    },
    localeOptions() {
      return this.toOptions(this.artworkFilter.NS_LOCALE);
    },
    authorOptions() {
      return this.toOptions(this.artworkFilter.NS_AUTHOR);
    },
    mainGroupOptions() {
      return this.toOptions(this.artworkFilter.NS_MAIN_GROUP);
    },
    subGroupOptions() {
      if (!this.mainGroup) return [];
      const selectMainGroup = this.artworkFilter.NS_MAIN_GROUP.find(
        (item) => item.id === this.mainGroup.value
      );
      return this.toOptions(selectMainGroup.subGroup);
    },
  },
  async mounted() {
    Promise.all([this.getArtworks(), this.getArtworkFilter()]);
    // await lazyloading();
  },
  methods: {
    ...mapMutations(['setArticleParams']),
    async getArtworks() {
      // 載入藝品列表頁，以 API 資料作為初始值
      const params = {};
      this.locale && (params.locale = this.locale.value);
      this.author && (params.author = this.author.value);
      this.mainGroup && (params.main_group = this.mainGroup.value);
      this.subGroup && (params.sub_group = this.subGroup.value);
      this.setArticleParams(params)

      try {
        await this.$store.dispatch('getArtworks', params);
      } catch (e) {
        console.error(e);
      }
    },
    async getArtworkFilter() {
      // 載入篩選的資料
      try {
        await this.$store.dispatch('getArtworkFilter');
      } catch (e) {
        console.error(e);
      }
    },
    handleChange(field, value) {
      this[field] = value;
      if (field === 'mainGroup') {
        this.$refs.subGroup.innerValue = null;
      }
      this.getArtworks();
    },
    handleReset(field) {
      this[field] = null;
      if (field === 'mainGroup') {
        this.$refs.subGroup.innerValue = null;
      }
      this.getArtworks();
    },
    toOptions(array = []) {
      return array.map(({ name, id }) => ({
        label: name,
        value: id,
      }));
    },
  },
  components: {
    TheListTitle,
    ArticleFilter,
    TheArticleList,
    TheListPagination,
    TheSelect,
  },
};
</script>

<style lang="scss" scoped>
.selector-group {
  text-align: center;
  padding-left: 10%;
  padding-right: 10%;

  &:first-child {
    margin-bottom: 10px;

    @include for-desktop {
      margin-bottom: 0;
      margin-right: 20px;
    }
  }

  @include for-desktop {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
